"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextUtils = /** @class */ (function () {
    function TextUtils() {
    }
    TextUtils.equals = function (arg0, arg1) {
        if (arg0 == null)
            return false;
        return arg0.localeCompare(arg1) === 0;
    };
    TextUtils.isEmpty = function (text) {
        return (!text || text === '');
    };
    return TextUtils;
}());
exports.default = TextUtils;

//# sourceMappingURL=TextUtils.js.map
